<script>
	// Stores
	import { 
		comoChegar,
		todosContatos, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		linkFacebook,
		linkInstagram,
		linkTwitter,
		linkLinkedin,
		linkBlog,
		linkWhatsappVendas,
		linkWhatsappLocacao,
		linkPoliticaPrivacidade,
		linkPoliticaCookies,
		social
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
</script>

<footer>
	<section class="footer-banner">
		<div class="container">
			<div class="flex sm-flex-column flex-center gap-10 pt-10 pb-10 flex-wrap" style="width: 100%;">
				{#each $todosContatos as contato, i}
				<div>
					<span><span class="hide-{i} hidden-sm hidden-xs">•</span> {@html contato.title}</span> <a target="_blank" href="{contato.href}">{@html contato.icon} {contato.phone}</a>
				</div>
				{/each}
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="content flex sm-flex-column sm-flex-center">
				<div class="seo">
					<img class="mb-20" src="/assets/images/logotipoFooter.png" alt="Imobiliária Zimmer" />
					<p>{@html $tagsSEO}</p>
				</div>
				<div class="flex-1 localizacao">
					<h4>Atendimento</h4>
					<p>{@html $textAtendimento}</p>
					<p>{@html $textEndereco}</p>
					<div class="travel flex gap-10 pb-20">
						{#each $comoChegar as link}
						<a href="{link.link}" target="_blank">{link.title} {@html link.icon}</a>
						{/each}
					</div>
				</div>
				<div class="sede">
					<h4>Siga nossas redes</h4>
					<div class="flex flex-column flex-right sm-flex-row sm-flex-center gap-10">
						{#each $social as item}
							<a href="{item.link}" title="Ir para {item.title}" target="_blank">{item.title} {@html item.icon != null ? item.icon : ""}</a>
						{/each}
					</div>

				</div>
			</div>
			<div class="content text-center pt-10">
				<a class="text-smaller" href={$linkPoliticaPrivacidade} target="_blank">- Política de Privacidade -</a>
			</div>
			<div class="copyright">
				<copy>@ 2023 - Imobiliária Zimmer - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os direitos reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></copy>
			</div>
		</div>
	</section>
</footer>